import { NgModule,APP_INITIALIZER } from '@angular/core';
import { CommonModule } from '@angular/common';
// import { Path, Config } from 'src/app/enums';
// import { InitService } from 'src/app/parsers/init.service';
import { BottomBarComponent } from './bottom-bar.component';
import { HttpClient,HttpClientModule } from '@angular/common/http';
import { DraggableModule } from './draggable/draggable.module';
 

// export function initBottomBar(initSrv: InitService) {
//   return () => initSrv.loadConfig({
//     path: Path.BOTTOMBAR_CONFIG_PATH, 
//     configType: Config.BOTTOMBAR_CONFIG
//   });
// }

@NgModule({
  declarations: [BottomBarComponent],
  imports: [
    CommonModule,
    HttpClientModule,
    DraggableModule
  ],
  exports : [BottomBarComponent, DraggableModule],
  // providers: [
  //   InitService,
  //   {
  //     provide: APP_INITIALIZER,
  //     useFactory: initBottomBar,
  //     deps: [InitService,HttpClient],
  //     multi: true,
  //   }
  // ],
})
export class BottomBarModule { }
